export interface Faq {
  id: string;
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    id: "faq-1",
    question: "漫画软件应用哪个好？怎么快速挑选？",
    answer:
      "没有绝对最好的漫画软件应用，只有最适合你的。建议先从『题材』和『付费意愿』两个维度出发：喜欢国漫原创可选快看漫画，主看正版日漫选哔哩哔哩漫画，追求免费海量选番茄漫画，专注韩漫则选咚漫。先明确核心需求，再看本站的漫画软件应用排行，基本就能快速锁定目标。",
  },
  {
    id: "faq-2",
    question: "有哪些免费追更的漫画软件应用？",
    answer:
      "主打免费的漫画软件应用主要有番茄漫画和漫画岛等。番茄漫画书库海量、完全免费，通过看广告或完成任务解锁更多章节；漫画岛则是资源聚合型应用，题材覆盖广、分类清晰。建议再搭配一款体验良好的正版应用，按需切换，既能省钱又不牺牲阅读质量。",
  },
  {
    id: "faq-3",
    question: "在哪里能看到正版日漫？",
    answer:
      "想看正版日漫，推荐哔哩哔哩漫画和腾讯动漫。哔哩哔哩漫画的正版日漫资源最全，且与动画联动紧密，支持离线缓存和跨端同步；腾讯动漫的IP生态更完整，适合喜欢同一IP多种形态的用户。选择正版平台，画质清晰、更新同步，也能支持创作者。",
  },
  {
    id: "faq-4",
    question: "同时追很多漫画总漏更怎么办？",
    answer:
      "漏更的根源往往是跨平台信息分散。可以使用追漫日记这类追更管理工具，把分布在不同漫画软件应用里的在追作品集中记录、统一提醒，再配合固定的每日刷新习惯，基本就能告别漏更。管理工具解决『记不住』，好习惯解决『忘去看』，两者结合最有效。",
  },
  {
    id: "faq-5",
    question: "下载漫画软件应用需要注意什么？",
    answer:
      "建议从官方应用商店下载，避免安装来路不明的安装包。安装时留意权限申请，只授予必要权限。同时警惕『完全免费』背后是否强制弹广告或诱导付费，理性看待会员与内购，按自己的追更量选择付费方案即可。",
  },
  {
    id: "faq-6",
    question: "一款漫画软件应用够用吗？",
    answer:
      "对大多数轻度读者，一款核心应用基本够用。但如果你口味很杂、同时追国漫、日漫、韩漫，或既想要免费又想要正版体验，建议保留一到两款互补的应用搭配使用，再配合追更管理工具，能让追更体验更完整、更省心。",
  },
];